import { FormControl, FormControlLabel, Radio, RadioGroup } from "@mui/material";
import { styled } from "styled-components";
import theme from "../../styles/theme";
import { useEffect, useState } from "react";

import EventNoteIcon from '@mui/icons-material/EventNote';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import ScheduleList from "./detail/ScheduleList";
import Schedule from "./detail/Schedule";

const MainWrap = styled.div`
    height: 100%;
    width: 100%;
    background: ${theme.color.white[100]};
    border-radius: 12px;
    padding: 0.5rem 1rem;
    .title_line {
        display: flex;
        justify-content: space-between;
        align-items: center;
        span {
            font-size: 1.25rem;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            gap: 8px;
        }
    }
`;


const Project = () => {

    const [toggle, setToggle] = useState(true);

    return (
        <MainWrap>
            <div className="title_line"><span><EventNoteIcon onClick={()=>setToggle(!toggle)}/>과업별 일정</span><MoreVertIcon /></div>
            {(toggle === true) ? <ScheduleList /> : <Schedule /> }
        </MainWrap>
    )

}

export default Project;